import { useQueryClient } from 'react-query';

import { queryKey } from '../../groups.query-keys';

export const useInvalidateAllGroups = () => {
    const queryClient = useQueryClient();

    return () => {
        queryClient.invalidateQueries(queryKey.groups());
    };
};
